import { useCallback } from "react";
import { useNavigate } from "react-router";
import { Box, Dialog, Paper, Typography } from "@mui/material";
import { Button } from "@covertree/ui";
import {
  selectPersonalDetailsBasicFormDefaultValues,
  selectShowInsuranceScoreNoHitModal,
  setShowInsuranceScoreNoHitModal,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";
import { useAppDispatch } from "@redux/hooks";

export function PersonalizedQuotesInsuranceScoreNoHitModal() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { firstName, lastName, insuredDateOfBirth } = useNewBusinessSelector(
    selectPersonalDetailsBasicFormDefaultValues
  );

  const showInsuranceScoreNoHitModal = useNewBusinessSelector(
    selectShowInsuranceScoreNoHitModal
  );

  const closeInsuranceScoreNoHitModal = useCallback(() => {
    dispatch(setShowInsuranceScoreNoHitModal(false));
  }, [dispatch]);

  const handleGoBack = useCallback(() => {
    closeInsuranceScoreNoHitModal();
    navigate(-1);
  }, [navigate]);

  return (
    <Dialog
      open={showInsuranceScoreNoHitModal}
      onClose={closeInsuranceScoreNoHitModal}>
      <Paper
        sx={(theme) => ({ margin: theme.spacing(3, 5), boxShadow: "none" })}>
        <img
          src="/images/icons/cross.webp"
          alt="cross"
          width="80px"
          height="80px"
        />
        <Typography variant="h4">Insurance Score No Hit</Typography>
        <Typography sx={(theme) => ({ color: theme.colors.grey1 })}>
          Couldn&#39;t find insurance score for{" "}
          <Typography
            component="span"
            sx={(theme) => ({ color: theme.colors.orange1 })}>
            {firstName} {lastName}{" "}
          </Typography>
          with date of birth{" "}
          <Typography
            component="span"
            sx={(theme) => ({ color: theme.colors.orange1 })}>
            {insuredDateOfBirth}
          </Typography>
          .
        </Typography>
        <Typography
          sx={(theme) => ({ color: theme.colors.grey1 })}
          variant="h6">
          To retry, click the back button to edit the customer&#39;s name and/or
          date of birth, otherwise continue.
        </Typography>
        <Box display="flex" mt={4} gap="20px">
          <Button
            type="submit"
            data-testid="inurance-score-no-hit-back"
            variant="outlined"
            onClick={handleGoBack}>
            Back
          </Button>
          <Button
            type="submit"
            onClick={closeInsuranceScoreNoHitModal}
            data-testid="insurance-score-no-hit-continue">
            Continue
          </Button>
        </Box>
      </Paper>
    </Dialog>
  );
}
